import { Button, Row } from "antd";
import { useCreatedAtLabel } from "../hooks/useCreatedAtLabel";
import { SyncOutlined } from "@ant-design/icons";

type HeaderProps = {
  data: any;
  disabled: boolean;
  recalculate: () => void;
};

export const Header = ({ data, disabled, recalculate }: HeaderProps) => {
  const { createdAtLabel } = useCreatedAtLabel(data);

  return (
    <Row className="py-6 mx-8 align-center justify-space-between">
      <h3 className="h h3">Home</h3>
      <Row className="align-center">
        {createdAtLabel}
        <Button
          className="ml-4"
          icon={<SyncOutlined />}
          shape="circle"
          disabled={disabled}
          onClick={recalculate}
        />
      </Row>
    </Row>
  );
};
